<div class="btn-group">
  @for (b of column.buttons; track b) {
    <button
      [hidden]="b.hidden && (typeof b.hidden === 'function' ? b.hidden(item) : b.hidden)"
      (click)="onButtonClick(b)"
      class="btn btn-sm btn-action"
      [ngClass]="{'btn-danger': b.isDelete, 'btn-primary': !b.isDelete}"
      [ngbTooltip]="b.tooltip">
      <i class="fa" [class]="b.icon"></i>
    </button>
  }
</div>
